import React, { useState, useEffect, useRef } from 'react';
import { MagnifyingGlass, Command, KeyReturn, ArrowsDownUp } from '@phosphor-icons/react';
import { get_icon } from '../utils/icon_map';
import { MmcBadge } from './ui';
import '../styles/mmc-global-search.css';

const MmcGlobalSearch = ({ games = [], onGameSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [query, setQuery] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const inputRef = useRef(null);

    const filteredGames = games.filter(m =>
        m.display_name.toLowerCase().includes(query.toLowerCase()) ||
        m.description.toLowerCase().includes(query.toLowerCase())
    );

    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                setIsOpen(true);
            }
            if (e.key === 'Escape') {
                setIsOpen(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    useEffect(() => {
        if (isOpen) {
            inputRef.current?.focus();
            setQuery('');
            setActiveIndex(0);
        }
    }, [isOpen]);

    const handleKeyDown = (e) => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setActiveIndex(prev => (prev + 1) % filteredGames.length);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setActiveIndex(prev => (prev - 1 + filteredGames.length) % filteredGames.length);
        } else if (e.key === 'Enter') {
            if (filteredGames[activeIndex]) {
                selectGame(filteredGames[activeIndex].id);
            }
        }
    };

    const selectGame = (gameId) => {
        onGameSelect(gameId);
        setIsOpen(false);
    };

    if (!isOpen) return null;

    return (
        <div className="mmc-global-search-overlay" onClick={() => setIsOpen(false)}>
            <div className="mmc-global-search" onClick={e => e.stopPropagation()}>
                <header className="mmc-global-search__header">
                    <MagnifyingGlass size={24} weight="bold" />
                    <input
                        ref={inputRef}
                        type="text"
                        className="mmc-global-search__input"
                        placeholder="Search for a game..."
                        value={query}
                        onChange={e => {
                            setQuery(e.target.value);
                            setActiveIndex(0);
                        }}
                        onKeyDown={handleKeyDown}
                    />
                    <div className="mmc-global-search__kbd">
                        <kbd><Command size={10} /></kbd>
                        <kbd>K</kbd>
                    </div>
                </header>

                <div className="mmc-global-search__results">
                    {filteredGames.length > 0 ? (
                        filteredGames.map((game, index) => (
                            <div
                                key={game.id}
                                className={`mmc-global-search__item ${index === activeIndex ? 'mmc-global-search__item--active' : ''}`}
                                onMouseEnter={() => setActiveIndex(index)}
                                onClick={() => selectGame(game.id)}
                            >
                                {get_icon(game.icon, 20, 'bold')}
                                <div className="mmc-global-search__item-info">
                                    <span className="mmc-global-search__item-title">{game.display_name}</span>
                                    <span className="mmc-global-search__item-desc">{game.description}</span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="mmc-global-search__empty">
                            No games found for "{query}"
                        </div>
                    )}
                </div>

                <footer className="mmc-global-search__footer">
                    <span className="mmc-global-search__hint">
                        <kbd><KeyReturn size={10} /></kbd> to select
                    </span>
                    <span className="mmc-global-search__hint">
                        <kbd><ArrowsDownUp size={10} /></kbd> to navigate
                    </span>
                    <span className="mmc-global-search__hint">
                        <kbd>ESC</kbd> to close
                    </span>
                </footer>
            </div>
        </div>
    );
};

export default MmcGlobalSearch;
